import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, defer, exhaustMap, forkJoin, mergeMap, tap } from "rxjs";
import { TelemetryActions } from "../actions";
import { TelemetryDataService, TelemetryService } from "../service";

@Injectable()
export class TelemetryEffects {
  private static readonly TELEMETRY_CREATE = $localize`Creating report..`;
  private static readonly TELEMETRY_CREATE_SUCCESS = $localize`Report created successfully.`;
  private static readonly TELEMETRY_CREATE_FAILURE = $localize`Report creation failed.`;

  constructor(
    private readonly actions$: Actions,
    private readonly telemetryService: TelemetryService,
    private readonly telemetryDataService: TelemetryDataService,
    private readonly matSnackBar: MatSnackBar
  ) {}

  create$ = createEffect(
    () =>
      this.actions$.pipe(ofType(TelemetryActions.create)).pipe(
        tap(() =>
          this.matSnackBar.open(TelemetryEffects.TELEMETRY_CREATE, "⏳", {
            duration: 15_000
          })
        ),
        exhaustMap(({ roomId, roomPid, accountIdentity }) =>
          defer(async () => this.telemetryDataService.telemetryGet()).pipe(
            mergeMap((_) =>
              forkJoin([
                new Promise((resolve) => setTimeout(resolve, 5_000)),
                this.telemetryService.create(
                  roomId,
                  roomPid,
                  accountIdentity,
                  _
                )
              ])
            ),
            tap(() =>
              this.matSnackBar.open(
                TelemetryEffects.TELEMETRY_CREATE_SUCCESS,
                "✅",
                {
                  duration: 15_000
                }
              )
            ),
            catchError(() => {
              this.matSnackBar.open(
                TelemetryEffects.TELEMETRY_CREATE_FAILURE,
                "🚫",
                {
                  duration: 15_000
                }
              );

              return [];
            })
          )
        )
      ),
    { dispatch: false }
  );
}
